import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyCustomField({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <filter
          x="-5.3%"
          y="-18.2%"
          width="110.6%"
          height="145.5%"
          filterUnits="objectBoundingBox"
          id="pic-empty-custom-field_svg__a"
        >
          <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={1.5} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.14 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <filter
          x="-8.1%"
          y="-30.6%"
          width="116.2%"
          height="172.2%"
          filterUnits="objectBoundingBox"
          id="pic-empty-custom-field_svg__c"
        >
          <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feComposite
            in="shadowBlurOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.06 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <filter
          x="-7%"
          y="-25%"
          width="114%"
          height="162.5%"
          filterUnits="objectBoundingBox"
          id="pic-empty-custom-field_svg__e"
        >
          <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={1.5} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.06 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <filter
          x="-20%"
          y="-20%"
          width="140%"
          height="140%"
          filterUnits="objectBoundingBox"
          id="pic-empty-custom-field_svg__g"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <rect id="pic-empty-custom-field_svg__b" x={75} width={94} height={22} rx={1} />
        <rect id="pic-empty-custom-field_svg__d" x={109} y={40} width={80.1} height={18} rx={0.9} />
        <rect id="pic-empty-custom-field_svg__f" x={38} width={71.2} height={16} rx={0.8} />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h240v168H0z" />
        <path
          d="M166 146c-45.28-3.13-66.68 14.56-111 14.56-39.06 0-63.7-44.94-49-77.06C21.72 49.15 75.45 49.92 108 28c93.53-63 112.5 22 126 64s-23.21 57.1-68 54z"
          fill="#E9EDFB"
        />
        <path
          d="M231.31 82.76l.35 1.28c.76 2.77 1.53 5.44 2.34 7.96 13.5 42-23.21 57.1-68 54-45.28-3.13-66.68 14.56-111 14.56-33.28 0-56.1-32.64-53.02-62.17 25.02 22.12 67.8 18.52 117.52-2.41 34.31-14.45 79.08-19.78 111.81-13.22z"
          fill="#8F9DD6"
          opacity={0.32}
        />
        <g transform="translate(30 70)">
          <use
            fill="#000"
            filter="url(#pic-empty-custom-field_svg__a)"
            xlinkHref="#pic-empty-custom-field_svg__b"
          />
          <use fill="#FFF" xlinkHref="#pic-empty-custom-field_svg__b" />
          <rect fillOpacity={0.8} fill="#6C7EC9" y={2} width={63} height={18} rx={1} />
        </g>
        <use
          fill="#000"
          filter="url(#pic-empty-custom-field_svg__c)"
          xlinkHref="#pic-empty-custom-field_svg__d"
        />
        <use fillOpacity={0.96} fill="#FFF" xlinkHref="#pic-empty-custom-field_svg__d" />
        <rect fill="#9CAAE5" x={58} y={41} width={40.5} height={15.2} rx={0.9} />
        <g transform="translate(68 103)">
          <use
            fill="#000"
            filter="url(#pic-empty-custom-field_svg__e)"
            xlinkHref="#pic-empty-custom-field_svg__f"
          />
          <use fill="#F5F7FF" xlinkHref="#pic-empty-custom-field_svg__f" />
          <rect fill="#A6B2E2" y={1} width={28.8} height={13.4} rx={0.8} />
        </g>
        <g filter="url(#pic-empty-custom-field_svg__g)" transform="translate(160 98)">
          <path
            d="M59.88 25.95c-.03-.45-.4-.84-.92-.98l-6.52-1.72a23.26 23.26 0 00-1.8-4.35l3.4-5.82c.27-.47.26-1-.05-1.34A69.17 69.17 0 0048.26 6c-.33-.3-.87-.32-1.34-.05l-5.82 3.4a23.29 23.29 0 00-4.35-1.8l-1.72-6.52c-.14-.53-.53-.9-.98-.92a69.13 69.13 0 00-8.1 0c-.45.03-.84.4-.98.92l-1.72 6.52a23.29 23.29 0 00-4.35 1.8l-5.82-3.4c-.47-.27-1-.26-1.34.05A69.17 69.17 0 006 11.74c-.3.33-.32.87-.05 1.34l3.4 5.82a23.29 23.29 0 00-1.8 4.35l-6.52 1.72c-.53.14-.9.53-.92.98a69.12 69.12 0 000 8.1c.03.45.4.84.92.98l6.52 1.72a23.29 23.29 0 001.8 4.35l-3.4 5.82c-.27.47-.26 1 .05 1.34A68.97 68.97 0 0011.74 54c.33.3.87.32 1.34.05l5.82-3.4c1.38.74 2.83 1.35 4.35 1.8l1.72 6.52c.14.53.53.9.98.92a68.97 68.97 0 008.1 0c.45-.03.84-.4.98-.92l1.72-6.52a23.26 23.26 0 004.35-1.8l5.82 3.4c.47.27 1 .26 1.34-.05A69.03 69.03 0 0054 48.26c.3-.33.32-.87.05-1.34l-3.4-5.82a23.26 23.26 0 001.8-4.35l6.52-1.72c.53-.14.9-.53.92-.98a68.98 68.98 0 000-8.1z"
            fill="#717074"
          />
          <path d="M30 43.93a13.93 13.93 0 110-27.86 13.93 13.93 0 010 27.86z" fill="#F9FAFA" />
          <path d="M30 21.43a8.57 8.57 0 100 17.14 8.57 8.57 0 000-17.14" fill="#666" />
        </g>
      </g>
    </svg>
  );
}

SvgPicEmptyCustomField.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyCustomField.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyCustomField svgRef={ref} {...props} />
));
export default ForwardRef;
